
export default {
  maps: {
    pageTitle: 'CycleAI | Route Planner',
    Places: 'Places',
    isochrones: 'Isochrones',
    placeNameRequired: 'Place name required',
    altitude: 'Altitude variation',
    settings: 'Settings',
    toggleAccessibleMode: 'Toggle accessible mode',
    aboutTitle: 'About ORS',
    updateSearch: 'Search this area',
    updateSearchAfterZoomOrCenterChange: 'Update search after zoom or center change'
  }
}
